import { render } from "./QbReportsItem.vue?vue&type=template&id=599a0b8d&scoped=true"
import script from "./QbReportsItem.vue?vue&type=script&lang=js"
export * from "./QbReportsItem.vue?vue&type=script&lang=js"

import "./QbReportsItem.vue?vue&type=style&index=0&id=599a0b8d&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599a0b8d"]])

export default __exports__